<template>
  <div>
    <base-header
      type="gradient-success"
      class="pb-6 pb-8 pt-5 pt-md-8 header_gradiant"
    ></base-header>
    <div class="container-fluid mt--7">
      <div class="card shadow p-3" :class="type === 'dark' ? 'bg-default' : ''">
        <h2>Relatórios</h2>

        <div class="row mb-3">
          <div class="col-12">
            <div class="report-type-switch">
              <label
                v-for="opt in reportTypes"
                :key="opt.value"
                class="report-type-option"
                :class="{ active: state.tipo_relatorio === opt.value }"
              >
                <input
                  type="radio"
                  :value="opt.value"
                  v-model="state.tipo_relatorio"
                />
                {{ opt.label }}
              </label>
            </div>
          </div>
        </div>

        <div class="row" v-if="state.tipo_relatorio === 'PACIENTE'">
          <div class="col-xl-3 col-lg-4 col-md-6 mb-3">
            <div class="form-group">
              <label for="tipo">Tipo</label>
              <select v-model="state.tipo" id="tipo">
                <option value="">TODOS</option>
                <option value="PACIENTE">PACIENTE</option>
                <option value="PET">PET</option>
              </select>
            </div>
          </div>

          <div class="col-xl-3 col-lg-4 col-md-6 mb-3">
            <div class="form-group">
              <label for="genero">Genero</label>
              <select v-model="state.genero" id="genero">
                <option value="">TODOS</option>
                <option value="MASCULINO">MASCULINO</option>
                <option value="FEMININO">FEMININO</option>
                <option value="OUTROS">OUTROS</option>
              </select>
            </div>
          </div>

          <div class="col-xl-3 col-lg-4 col-md-6 mb-3">
            <div class="form-group">
              <label for="idade">Idade</label>
              <select v-model="state.idade" id="idade">
                <option value="">TODOS</option>
                <option value="16-30">16-30</option>
                <option value="31-45">31-45</option>
                <option value="46-60">46-60</option>
                <option value="61+">61+</option>
              </select>
            </div>
          </div>

          <div class="col-xl-3 col-lg-4 col-md-6 mb-3">
            <div class="form-group">
              <label for="entrevista">Com Entrevista Social</label>
              <select v-model="state.entrevista" id="entrevista">
                <option value="">TODOS</option>
                <option value="COM">Com Entrevista</option>
                <option value="SEM">Sem Entrevista</option>
              </select>
            </div>
          </div>

          <div class="col-xl-3 col-lg-4 col-md-6 mb-3">
            <div class="form-group">
              <label for="medico">Médico</label>
              <select v-model="state.medico" id="medico">
                <option value="">TODOS</option>
                <option
                  v-for="medico in state.medicos"
                  :key="medico.id"
                  :value="medico.id"
                >
                  {{ medico.nome }}
                </option>
              </select>
            </div>
          </div>

          <div class="col-xl-3 col-lg-4 col-md-6 mb-3">
            <div class="form-group">
              <label for="patologia">Patologia</label>
              <select v-model="state.patologia" id="patologia">
                <option value="">TODAS</option>
                <option
                  v-for="patologia in state.patologias"
                  :key="patologia.id"
                  :value="patologia.id"
                >
                  {{ patologia.nome }}
                </option>
              </select>
            </div>
          </div>

          <div class="col-xl-3 col-lg-4 col-md-6 mb-3">
            <div class="form-group">
              <label for="oleo">Óleo</label>
              <select v-model="state.oleo" id="oleo">
                <option value="">TODOS</option>
                <option
                  v-for="oleo in state.oleos"
                  :key="oleo.id"
                  :value="oleo.id"
                >
                  {{ oleo.nome }}
                </option>
              </select>
            </div>
          </div>

          <div class="col-xl-3 col-lg-4 col-md-6 mb-3">
            <div class="form-group">
              <label for="estado">Estado</label>
              <select v-model="state.estado" id="estado">
                <option value="">TODOS</option>
                <option
                  v-for="estado in state.estados"
                  :key="estado.id"
                  :value="estado.uf"
                >
                  {{ estado.estado }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="row" v-if="state.tipo_relatorio === 'OLEO'">
          <div class="col-xl-3 col-lg-4 col-md-6 mb-3">
            <div class="form-group">
              <label for="oleo_filtro">Óleo</label>
              <select v-model="state.oleo" id="oleo_filtro">
                <option value="">TODOS</option>
                <option
                  v-for="oleo in state.oleos"
                  :key="oleo.id"
                  :value="oleo.id"
                >
                  {{ oleo.nome }}
                </option>
              </select>
            </div>
          </div>

          <div class="col-xl-3 col-lg-4 col-md-6 mb-3">
            <div class="form-group">
              <label for="status_oleo">Status</label>
              <select v-model="state.status" id="status_oleo">
                <option value="">TODOS</option>
                <option value="ATIVO">ATIVO</option>
                <option value="INATIVO">INATIVO</option>
              </select>
            </div>
          </div>
        </div>

        <div class="row" v-if="state.tipo_relatorio === 'ENTREGA'">
          <div class="col-xl-3 col-lg-4 col-md-6 mb-3">
            <div class="form-group">
              <label for="oleo_entrega">Óleo</label>
              <select v-model="state.oleo" id="oleo_entrega">
                <option value="">TODOS</option>
                <option
                  v-for="oleo in state.oleos"
                  :key="oleo.id"
                  :value="oleo.id"
                >
                  {{ oleo.nome }}
                </option>
              </select>
            </div>
          </div>

          <div class="col-xl-3 col-lg-4 col-md-6 mb-3">
            <div class="form-group">
              <label for="paciente_entrega">Paciente</label>
              <select v-model="state.paciente" id="paciente_entrega">
                <option value="">TODOS</option>
                <option
                  v-for="paciente in state.pacientes"
                  :key="paciente.id"
                  :value="paciente.id"
                >
                  {{ paciente.pessoa ? paciente.pessoa.nome : paciente.nome }}
                </option>
              </select>
            </div>
          </div>

          <div class="col-xl-3 col-lg-4 col-md-6 mb-3">
            <div class="form-group">
              <label for="data_inicial">Data Inicial</label>
              <input
                type="date"
                v-model="state.data_inicial"
                id="data_inicial"
              />
            </div>
          </div>

          <div class="col-xl-3 col-lg-4 col-md-6 mb-3">
            <div class="form-group">
              <label for="data_final">Data Final</label>
              <input type="date" v-model="state.data_final" id="data_final" />
            </div>
          </div>
        </div>

        <div class="row">
          <div
            class="col-xl-2 col-lg-3 col-md-4 ms-auto d-flex justify-content-center align-items-end mb-3"
          >
            <button
              @click="generatePdf"
              class="btn_novo"
              type="button"
              title="Gerar PDF"
              :disabled="state.loading"
            >
              Gerar PDF
            </button>
          </div>
        </div>

        <div class="table-responsive mt-4" v-if="state.result.length">
          <table class="table table-striped" v-if="state.resultType === 'PACIENTE'">
            <thead>
              <tr>
                <th scope="col">Nome</th>
                <th scope="col">Telefone</th>
                <th scope="col">Patologia</th>
                <th scope="col">Data de Cadastro</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(paciente, idx) in state.result" :key="idx">
                <td>{{ paciente.nome }}</td>
                <td>{{ paciente.telefone }}</td>
                <td>{{ paciente.patologia }}</td>
                <td>{{ paciente.data_cadastro }}</td>
              </tr>
            </tbody>
          </table>

          <table class="table table-striped" v-if="state.resultType === 'MEDICO'">
            <thead>
              <tr>
                <th scope="col">Nome</th>
                <th scope="col">Conselho</th>
                <th scope="col">Data de Cadastro</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(medico, idx) in state.result" :key="idx">
                <td>{{ medico.nome }}</td>
                <td>{{ medico.conselho }}</td>
                <td>{{ medico.data_criacao }}</td>
              </tr>
            </tbody>
          </table>

          <table class="table table-striped" v-if="state.resultType === 'COOPERADOR'">
            <thead>
              <tr>
                <th scope="col">Nome</th>
                <th scope="col">Telefone</th>
                <th scope="col">Data de Cadastro</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(cooperador, idx) in state.result" :key="idx">
                <td>{{ cooperador.nome }}</td>
                <td>{{ cooperador.telefone }}</td>
                <td>{{ cooperador.created_at }}</td>
              </tr>
            </tbody>
          </table>

          <table class="table table-striped" v-if="state.resultType === 'OLEO'">
            <thead>
              <tr>
                <th scope="col">Código</th>
                <th scope="col">Nome</th>
                <th scope="col">Status</th>
                <th scope="col">Estoque</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(oleo, idx) in state.result" :key="idx">
                <td>{{ oleo.id }}</td>
                <td>{{ oleo.nome }}</td>
                <td>{{ oleo.status }}</td>
                <td>{{ oleo.estoque }}</td>
              </tr>
            </tbody>
          </table>

          <table class="table table-striped" v-if="state.resultType === 'ENTREGA'">
            <thead>
              <tr>
                <th scope="col">Paciente</th>
                <th scope="col">Óleo</th>
                <th scope="col">Quantidade</th>
                <th scope="col">Data</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(entrega, idx) in state.result" :key="idx">
                <td>{{ entrega.paciente }}</td>
                <td>{{ entrega.oleo }}</td>
                <td>{{ entrega.quantidade }}</td>
                <td>{{ entrega.data }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p v-else-if="state.searched && !state.loading" class="text-center text-muted mt-4">
          Nenhum resultado encontrado para os filtros selecionados.
        </p>
      </div>
    </div>
    <div v-if="state.loading === true">
      <div class="loader"></div>
    </div>
  </div>
</template>
<script>
import { ref, reactive, onMounted } from "vue";
import services from "../../services";
import { useStorage } from "vue3-storage";
import jsPDF from "jspdf";
import "jspdf-autotable";

export default {
  setup() {
    const storage = useStorage();
    const token = storage.getStorageSync("token");

    const reportTypes = [
      { value: "PACIENTE", label: "Paciente" },
      { value: "MEDICO", label: "Médico" },
      { value: "COOPERADOR", label: "Cooperador" },
      { value: "OLEO", label: "Óleos" },
      { value: "ENTREGA", label: "Entregas" },
    ];

    const state = reactive({
      genero: "",
      estado: "",
      idade: "",
      tipo_relatorio: "PACIENTE",
      pacientes: [],
      medicos: [],
      oleos: [],
      patologias: [],
      oleo: "",
      entrevista: "",
      patologia: "",
      medico: "",
      paciente: "",
      status: "",
      data_inicial: "",
      data_final: "",
      tipo: "",
      loading: false,
      result: [],
      resultType: "",
      searched: false,
      estados: [
        { estado: "Acre", uf: "AC" },
        { estado: "Alagoas", uf: "AL" },
        { estado: "Amapá", uf: "AP" },
        { estado: "Amazonas", uf: "AM" },
        { estado: "Bahia", uf: "BA" },
        { estado: "Ceará", uf: "CE" },
        { estado: "Distrito Federal", uf: "DF" },
        { estado: "Espírito Santo", uf: "ES" },
        { estado: "Goiás", uf: "GO" },
        { estado: "Maranhão", uf: "MA" },
        { estado: "Mato Grosso", uf: "MT" },
        { estado: "Mato Grosso do Sul", uf: "MS" },
        { estado: "Minas Gerais", uf: "MG" },
        { estado: "Pará", uf: "PA" },
        { estado: "Paraíba", uf: "PB" },
        { estado: "Paraná", uf: "PR" },
        { estado: "Pernambuco", uf: "PE" },
        { estado: "Piauí", uf: "PI" },
        { estado: "Rio de Janeiro", uf: "RJ" },
        { estado: "Rio Grande do Norte", uf: "RN" },
        { estado: "Rio Grande do Sul", uf: "RS" },
        { estado: "Rondônia", uf: "RO" },
        { estado: "Roraima", uf: "RR" },
        { estado: "Santa Catarina", uf: "SC" },
        { estado: "São Paulo", uf: "SP" },
        { estado: "Sergipe", uf: "SE" },
        { estado: "Tocantins", uf: "TO" },
      ],
    });

    const contentRef = ref(null);

    onMounted(() => {
      state.tipo_relatorio = "PACIENTE";
      fetchMedicos();
      fetchOleos();
      fetchPatologia();
      fetchPacientes();
    });

    async function fetchPacientes() {
      state.loading = true;

      try {
        const { data } = await services.paciente.getAll({ token });
        state.pacientes = data;
      } catch (error) {
        void error;
      }
      state.loading = false;
    }

    async function fetchMedicos() {
      state.loading = true;

      try {
        const { data } = await services.medicos.getAll({ token });
        state.medicos = data;
      } catch (error) {
        void error;
      }
      state.loading = false;
    }

    async function fetchOleos() {
      state.loading = true;

      try {
        const { data } = await services.tipos_oleo.getAll({ token });
        state.oleos = data;
      } catch (error) {
        void error;
      }
      state.loading = false;
    }

    async function fetchPatologia() {
      state.loading = true;

      try {
        const { data } = await services.patologia.getAll({ token });
        state.patologias = data;
      } catch (error) {
        void error;
      }
      state.loading = false;
    }

    function formatDate(dateString) {
      const options = { day: "2-digit", month: "2-digit", year: "numeric" };
      const date = new Date(dateString);
      return date.toLocaleDateString("pt-BR", options);
    }

    function generatePdf() {
      if (!state.tipo_relatorio) {
        alert("Selecione um relatório para gerar.");
        return;
      }

      state.loading = true;
      state.searched = false;

      const tipoRelatorio = state.tipo_relatorio;

      services.relatorios
        .get({
          genero: state.genero,
          oleo: state.oleo,
          entrevista: state.entrevista,
          patologia: state.patologia,
          medico: state.medico,
          paciente: state.paciente,
          status: state.status,
          data_inicial: state.data_inicial,
          data_final: state.data_final,
          tipo: state.tipo,
          tipo_relatorio: tipoRelatorio,
          idade: state.idade,
          estado: state.estado,
          token,
        })
        .then(({ data }) => {
          const dados = Array.isArray(data) ? data : data.dados || [];
          const result = dados.map((item) => ({
            ...item,
            data_cadastro: item.data_cadastro ? formatDate(item.data_cadastro) : item.data_cadastro,
            created_at: item.created_at ? formatDate(item.created_at) : item.created_at,
            data_criacao: item.data_criacao ? formatDate(item.data_criacao) : item.data_criacao,
            data: item.data ? formatDate(item.data) : item.data,
          }));

          state.result = result;
          state.resultType = tipoRelatorio;
          state.loading = false;
          state.searched = true;

          if (result.length) {
            buildAndSavePdf(tipoRelatorio, result);
          }
        })
        .catch((error) => {
          void error;
          state.result = [];
          state.loading = false;
          state.searched = true;
        });
    }

    function buildAndSavePdf(tipoRelatorio, result) {
      const doc = new jsPDF({ orientation: "portrait" });
      const columns = [];
      const rows = [];

      if (tipoRelatorio === "PACIENTE") {
        columns.push("Nome", "Telefone", "Patologia", "Data de Cadastro");
        result.forEach((paciente) => {
          rows.push([
            paciente.nome,
            paciente.telefone,
            paciente.patologia,
            paciente.data_cadastro,
          ]);
        });
      } else if (tipoRelatorio === "MEDICO") {
        columns.push("Nome", "Conselho", "Data de Cadastro");
        result.forEach((medico) => {
          rows.push([medico.nome, medico.conselho, medico.data_criacao]);
        });
      } else if (tipoRelatorio === "COOPERADOR") {
        columns.push("Nome", "Telefone", "Data de Cadastro");
        result.forEach((cooperador) => {
          rows.push([
            cooperador.nome,
            cooperador.telefone,
            cooperador.created_at,
          ]);
        });
      } else if (tipoRelatorio === "OLEO") {
        columns.push("Código", "Nome", "Status", "Estoque");
        result.forEach((oleo) => {
          rows.push([oleo.id, oleo.nome, oleo.status, oleo.estoque]);
        });
      } else if (tipoRelatorio === "ENTREGA") {
        columns.push("Paciente", "Óleo", "Quantidade", "Data");
        result.forEach((entrega) => {
          rows.push([
            entrega.paciente,
            entrega.oleo,
            entrega.quantidade,
            entrega.data,
          ]);
        });
      }

      const headerStyles = {
        fillColor: [22, 82, 78],
        textColor: [255, 255, 255],
        fontStyle: "bold",
      };
      var margin = 20;

      if (state.genero) {
        doc.text("Genero: " + state.genero, 10, margin);
        margin += 10;
      }
      if (state.entrevista) {
        doc.text("Entrevista: " + state.entrevista, 10, margin);
        margin += 10;
      }
      if (state.patologia) {
        doc.text("Patologia: " + state.patologia, 10, margin);
        margin += 10;
      }
      if (state.medico) {
        doc.text("Medico: " + state.medico, 10, margin);
        margin += 10;
      }
      if (state.tipo) {
        doc.text("Tipo: " + state.tipo, 10, margin);
        margin += 10;
      }
      if (state.idade) {
        doc.text("Idade: " + state.idade, 10, margin);
        margin += 10;
      }
      if (state.estado) {
        doc.text("Estado: " + state.estado, 10, margin);
        margin += 10;
      }
      if (state.status) {
        doc.text("Status: " + state.status, 10, margin);
        margin += 10;
      }
      if (state.paciente) {
        doc.text("Paciente: " + state.paciente, 10, margin);
        margin += 10;
      }
      if (state.data_inicial) {
        doc.text("Data Inicial: " + state.data_inicial, 10, margin);
        margin += 10;
      }
      if (state.data_final) {
        doc.text("Data Final: " + state.data_final, 10, margin);
        margin += 10;
      }

      doc.autoTable({
        head: [columns],
        body: rows,
        headStyles: headerStyles,
        styles: {
          fontSize: 8,
          cellPadding: 2,
        },
        margin: { top: margin },
        columnStyles: {
          0: { cellWidth: "auto" },
          1: { cellWidth: "wrap" },
          2: { cellWidth: 40 },
          3: { cellWidth: 30 },
        },
      });

      doc.save(`relatorio_${tipoRelatorio.toLowerCase()}_apracam.pdf`);
    }

    return {
      state,
      contentRef,
      generatePdf,
      reportTypes,
    };
  },
};
</script>

<style scoped>
.header_gradiant {
  background: linear-gradient(
    50deg,
    #007c7c 0%,
    #030c0c 100%,
    #007c7c
  ) !important;
}

select {
  color: #000;
  border: solid 2px rgb(10, 36, 35);
  border-color: rgb(10, 36, 35);
  padding: 10px;
  font-size: 12pt;
  width: 100%;
  border-radius: 4px;
}

select:focus {
  color: #000;
  border: solid 2px rgb(40, 149, 146);
  border-color: rgb(40, 149, 146);
}

input[type="date"] {
  color: #000;
  border: solid 2px rgb(10, 36, 35);
  border-color: rgb(10, 36, 35);
  padding: 9px 10px;
  font-size: 12pt;
  width: 100%;
  border-radius: 4px;
}

input[type="date"]:focus {
  color: #000;
  border: solid 2px rgb(40, 149, 146);
  border-color: rgb(40, 149, 146);
  outline: none;
}

label {
  color: #000;
  margin-bottom: 0;
  font-size: 14pt;
}

.report-type-switch {
  display: inline-flex;
  flex-wrap: wrap;
  gap: 8px;
}

.report-type-option {
  display: inline-flex;
  align-items: center;
  margin: 0;
  padding: 8px 18px;
  font-size: 12pt;
  font-weight: 600;
  color: rgb(22, 82, 78);
  background-color: #fff;
  border: solid 2px rgb(22, 82, 78);
  border-radius: 999px;
  cursor: pointer;
  transition: 0.25s;
}

.report-type-option input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.report-type-option:hover {
  background-color: rgba(22, 82, 78, 0.08);
}

.report-type-option.active {
  color: #fff;
  background-color: rgb(22, 82, 78);
}

.table-responsive table {
  color: #000;
}

.btn_novo {
  border-radius: 4px;
  width: 100%;
  height: 45px;
  padding: 5px;
  transition: 0.5s;
  background-color: rgb(22, 82, 78);
  border: solid 2px rgb(22, 82, 78);
  color: #fff;
}

.btn_novo:hover {
  background-color: rgb(40, 149, 146);
  border: solid 2px rgb(40, 149, 146);
}

.btn_novo:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Estilo do loader */
.loader {
  border: 4px solid rgb(10, 36, 35);
  border-left-color: transparent;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin89345 1s linear infinite;
  position: fixed;
  /* Usar position: fixed para centralizar em toda a tela */
  top: 50%;
  /* Centraliza verticalmente */
  left: 50%;
  /* Centraliza horizontalmente */
  transform: translate(-50%, -50%);
  /* Ajusta a posição para alinhar ao centro */
  z-index: 9999;
  /* Garante que o loader fique na frente de outros elementos */
}

/* Animação do loader */
@keyframes spin89345 {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

@media (max-width: 600px) {
  .loader {
    width: 30px;
    height: 30px;
    border: 3px solid rgb(10, 36, 35);
  }
}

@media (max-width: 767px) {
  .btn_novo {
    margin-top: 1rem;
  }
}
</style>
